import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let DeleteProjectThunk = createAsyncThunk(
	"Projects/DeleteProjectThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.delete(`api/admin/projects/${arg?.id}`);

			return res.data;
		} catch (error) {
			// console.log(error.response.data);
			return rejectWithValue(error.response.data);
		}
	}
);
